export interface AddressBooksState {
    addressBooks: AddressBookItem[]
    addressBookItem?: AddressBookItem
    addressBookContacts: AddressBookContactItem[]
    addressBookContactItem?: AddressBookContactItem
}

export interface AddressBookFilter {
    name?: string,
}

export class AddressBookItem {
    groupId?: number
    id?: number
    create_date?: string
    name?: string
    comment?: string
    contacts?: number
    checkDuplicatesPolicy?: number = 3
    checkDisposable?: number = 1
    checkRoleBased?: number = 1
    checkExistence?: number = 1
}

export interface AddressBookContactItem {
    id?: number,
    create_date?: string,
    msisdn?: string,
    email?: string,
    description?: string,
}

export class AddressBookContactsFilter {
    groupId?: string = undefined
    msisdn?: string = undefined
    email?: string = undefined
    page_number?: number = 1

    constructor(groupId: string) {
        this.groupId = groupId
    }
}

export class AddressBookImportRequest {
    groupId: number|null = null
    fileName: string|null = null
    file: string|null = null
    dateFormat: number = 1
    separator: string = ','
    uniquenessPolicy: number = 1
    fieldSequence: Array<string> = []

    constructor(groupId: number) {
        this.groupId = groupId
    }
}
